import type { SVGProps } from "react";

function GithubIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg height="25" viewBox="0 0 25 25" width="25" {...props}>
      <path
        d="M12.5.16C5.64.16 0 5.81 0 12.66c0 5.37 3.46 10.16 8.55 11.86.62.12.85-.27.85-.6 0-.3 0-1.08-.02-2.13-3.47.76-4.2-1.67-4.2-1.67a3.31 3.31 0 00-1.4-1.83c-1.13-.78.1-.76.1-.76.8.11 1.5.59 1.9 1.29a2.66 2.66 0 003.65 1.04c.05-.64.33-1.23.79-1.68-2.78-.31-5.7-1.38-5.7-6.17a4.83 4.83 0 011.3-3.36 4.5 4.5 0 01.11-3.3C6.4 4.3 6.98 5 9.37 6.62c2.05-.56 4.21-.56 6.26 0 2.39-1.62 3.43-1.29 3.43-1.29.47 1.05.51 2.23.13 3.31.84.91 1.3 2.12 1.28 3.36 0 4.8-2.92 5.86-5.7 6.16.6.62.9 1.46.85 2.32l-.02 3.43c0 .33.23.72.86.6 5.09-1.7 8.54-6.5 8.54-11.86C25 5.8 19.36.16 12.5.16z"
        fill="currentColor"
      />
    </svg>
  );
}

export default GithubIcon;
